import * as cx from 'classnames';
import range from 'lodash-es/range';
import { FORUM_ADD_QUESTION, TOPIC_COUNSELLOR } from 'mk/autogenerated/translations/Counselling.7c39c9a497368dfbfed4d7d9ac748f29'
import { CounsellingEntity, PostEntity } from 'mk2/apps/forum/schemas';
import * as urls from 'mk2/apps/forum/urls';
import AvatarImg from 'mk2/components/AvatarImg';
import { BtnType, default as Btn } from 'mk2/components/Btn';
import Link from 'mk2/components/Link';
import LinkListItem, { LinkListItemPlaceholder } from 'mk2/components/LinkListItem';
import LoadingPlaceholder from 'mk2/components/LoadingPlaceholder';
import Panel from 'mk2/components/Panel';
import PanelHeading, { PanelHeadingPlaceholder } from 'mk2/components/PanelHeading';
import { url } from 'mk2/helpers/urls';
import * as React from 'react';
import styles from './Counselling.mscss';

interface OwnProps {
    className?: string;
    posts: PostEntity[];
    counselling: CounsellingEntity;

    onAddPostClick?(event);
}

type Props = OwnProps;

const Counselling: React.FunctionComponent<Props> = ({ className, counselling, posts, onAddPostClick }) => (
    <Panel className={cx(styles.Counselling, className)}>
        <PanelHeading
            title={posts[0].topic.name}
            url={url(urls.forumTopic, { topicSlug: posts[0].topic.slug })}
        />
        <Link className={styles.Counselling__header} to={url(urls.forumTopic, { topicSlug: posts[0].topic.slug })}>
            <AvatarImg
                size={36}
                user={counselling.counsellor}
                className={styles.Counselling__header__avatar}
                counsellorAvatar={counselling.counsellorAvatar}
            />
            <div className={styles.Counselling__header__info}>
                <div className={styles.Counselling__header__info__name}>
                    {counselling.counsellorName}
                </div>
                <div className={styles.Counselling__header__info__badge}>
                    {TOPIC_COUNSELLOR}
                </div>
            </div>
        </Link>
        <ul className={styles.Counselling__list}>
            {posts.map((post, index) => (
                <LinkListItem
                    key={post.id}
                    to={url(urls.forumPostDetail, {topicSlug: post.topic.slug, postSlug: post.slug}, {})}
                    title={post.heading}
                />
            ))}
        </ul>
        <Btn
            className={styles.Counselling__btn}
            key="btn"
            type={BtnType.BlueOutline}
            label={FORUM_ADD_QUESTION}
            link={url(urls.forumCounsellingNew, { topicSlug: posts[0].topic.slug })}
            onClick={onAddPostClick}
        />
    </Panel>
);

Counselling.displayName = 'Counselling';

export default Counselling;

interface PlaceholderOwnProps {
    className?: string;
    length?: number;
}

export const CounsellingPlaceholder: React.FunctionComponent<PlaceholderOwnProps> = ({ className, length = 4 }) => (
    <Panel className={cx(styles.CounsellingPlaceholder, className)}>
        <PanelHeadingPlaceholder />
        <div className={styles.CounsellingPlaceholder__header}>
            <LoadingPlaceholder className={styles.Counselling__header__avatar} width={36} height={36}/>
            <div className={styles.Counselling__header__info}>
                <div className={styles.Counselling__header__info__name}>
                    <LoadingPlaceholder width={200} height={15}/>
                </div>
                <div className={styles.Counselling__header__info__badge}>
                    {TOPIC_COUNSELLOR}
                </div>
            </div>
        </div>

        <ul className={styles.CounsellingPlaceholder__list}>
            {range(length).map((idx) => (
                <LinkListItemPlaceholder key={idx} width={`${ [90, 85, 80, 70, 75, 85][idx % 6] }%`} />
            ))}
        </ul>
        <Btn
            key="btn"
            className={styles.Counselling__btn}
            type={BtnType.BlueOutline}
            label={FORUM_ADD_QUESTION}
            link={null}
        />
    </Panel>
);
